
import { LogicRuleCard } from "../../result/LogicRuleCard";
import { OrderComparison } from "../../result/OrderComparison";
import { ResultActions } from "../../result/ResultActions";
import { Button } from "@/components/ui/button";
import { FooterAttribution } from "../../result/FooterAttribution";
import { useResultQuips } from "@/hooks/useResultQuips";
import type { GameResult } from "@/hooks/useGameFlow";
import type { DailyPuzzle } from "@/lib/types/game";

interface GameResultContentProps {
  currentResult: GameResult;
  puzzle: DailyPuzzle;
  onVetoClick: () => void;
  onReasoningClick: () => void;
  isUsingExternalData?: boolean;
}

export function GameResultContent({
  currentResult,
  puzzle,
  onVetoClick,
  onReasoningClick,
  isUsingExternalData = false
}: GameResultContentProps) {
  const { quip } = useResultQuips();
  
  const formatQuipLines = (text: string): string[] => {
    const parts = text.split("! ");
    const firstLine = parts[0] + "!";
    const remainingText = parts[1] || "";
    const words = remainingText.split(' ');
    const lines: string[] = [firstLine];
    let currentLine = '';

    words.forEach(word => {
      if ((currentLine + ' ' + word).trim().length > 25) {
        if (currentLine) lines.push(currentLine.trim());
        currentLine = word;
      } else {
        currentLine = currentLine ? `${currentLine} ${word}` : word;
      }
    });

    if (currentLine) {
      lines.push(currentLine.trim());
    }

    return lines;
  };

  const quipLines = formatQuipLines(quip);
  const { result, selectedWords, selectedRule } = currentResult;

  return (
    <div className="space-y-6 w-full max-w-md">
      <div className="w-full flex justify-center mb-6">
        <div onClick={onReasoningClick} className="cursor-pointer">
          <LogicRuleCard rule={puzzle.correctRule} />
        </div>
      </div>
      
      <OrderComparison 
        selectedWords={selectedWords} 
        targetOrder={puzzle.correctOrder}
        solveTime={currentResult.solveTime}
        wordLinks={puzzle.wordLinks}
      />
      
      <div className="flex justify-center my-4">
        {result === "perfect" ? (
          <div className="text-center text-black font-bold italic font-['Times_New_Roman']">
            {quipLines.map((line, index) => (
              <div key={index}>{line}</div>
            ))}
          </div>
        ) : (
          <Button 
            onClick={onVetoClick} 
            className="bg-[#ea384c] hover:bg-[#d41d32] text-white font-medium rounded-md py-2 px-8"
          >
            VETO
          </Button>
        )}
      </div>
      
      <ResultActions 
        result={result}
        solveTime={currentResult.solveTime}
        isUsingExternalData={isUsingExternalData}
        selectedWords={selectedWords}
        targetOrder={puzzle.correctOrder}
        selectedRule={selectedRule}
      />
      
      <FooterAttribution />
    </div>
  );
}
